import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import ReferralCodeBg from '@src/assets/images/referral-code-background.png';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

export const StyledReferralCode = styled('div')`
  width: 100%;
  .code-section-container {
    background: ${COLOR.white};
    padding: 24px;
    gap: 24px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 16px;
    }
  }

  .new-ui-referral-code-item-container {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 24px;
    width: 100%;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      flex-direction: column;
      flex: 1;
      width: 100%;
      gap: 16px;
      align-items: center;
    }
  }

  .referral-code-bg {
    background-image: url(${ReferralCodeBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 16px;
    border-radius: 16px;
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .item-title,
  .item-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .item-value {
    padding: 12px 16px;
    border-radius: 12px;
    color: ${COLOR.subText};
    background-color: ${COLOR.charcoal};
    display: flex;
    gap: 8px;
  }

  .item-value-text {
    padding-right: 0;
    flex: 1;
    font-size: 14px;
    line-height: 20px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .item-label {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: ${COLOR.darkGray};
  }

  .MuiButtonBase-root {
    padding: 0;
  }

  .edit-button {
    color: ${COLOR.darkGray};
    cursor: pointer;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .copy-button {
    color: ${COLOR.indigo[80]};
  }
`;

export const StyledReferralSharing = styled('div')`
  .social-share-wrapper {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    padding-top: 16px;
  }

  .share-button,
  .zalo-share-button {
    width: 56px;
    min-width: 56px !important;
    height: 56px;
    border: 1px solid #ddd;
    border-radius: 14px;
    padding: 8px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    cursor: pointer;
  }

  .share-button img,
  .zalo-share-button img {
    width: 38px;
    height: 38px;
    object-fit: contain;
  }

  .section-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    color: rgba(28, 28, 30, 0.64);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    width: 100%;
    min-height: 20px;
  }

  .section-divider span {
    white-space: nowrap;
    flex-shrink: 0;
    padding: 0 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .section-divider::before,
  .section-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(60, 60, 67, 0.16);
    min-width: 30px; /* Ensure lines are visible even with long text */
  }

  .section-divider::before {
    margin-right: 0;
  }

  .section-divider::after {
    margin-left: 0;
  }

  @media only screen and (max-width: 480px) {
    .section-divider span {
      white-space: normal;
      text-align: center;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .share-button,
    .zalo-share-button,
    a.share-button,
    button.share-button {
      width: 48px;
      height: 48px;
      padding: 0;
      max-width: 48px;
      min-height: 48px;
      max-height: 48px;
      box-sizing: border-box;
      min-width: 48px !important;
    }

    .share-button img,
    .zalo-share-button img,
    a.share-button img,
    button.share-button img {
      width: 24px;
      height: 24px;
      min-width: 24px !important;
      max-width: 24px;
      min-height: 24px;
      max-height: 24px;
      object-fit: contain;
    }

    .share-button.MuiButton-root .MuiButton-startIcon,
    .share-button.MuiButton-root .MuiButton-endIcon {
      margin: 0 !important;
    }

    .share-button > *:not(img),
    .zalo-share-button > *:not(img) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
